module.exports = __webpack_public_path__ + "media/customizations/jordanranch/logo-new-616dc013a0372c1494cee37423b9461d.png";